import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import "../css/layout.css";
import "../css/login.css";
import findGif from "../css/loading_old.gif";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from '../../apiService/allApi'


export default function Login() {
  const history = useHistory();
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 

  const { referralcode } = useParams();

  const [Phone, setPhone] = useState();
  const [twofactor_code, settwofactor_code] = useState();
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();

  let refs = useLocation().pathname.split("/")[2];
  const [referral, setReferral] = useState(refs);

  const handleClick = async (e) => {
    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
    } else if (Phone.length != 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please  enter currect phone number",
      });
    } else {
      setIsloading1(true)

      const respone = await apiRequest('login', "POST", { Phone, referral, })
      // .then((respone) => {
      setIsloading1(false)
      if (respone?.data?.status == 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: respone?.data?.msg,
        });
      } else if (respone?.data?.status == 200) {
        setOtp(true);
        setSecretCode(respone?.data?.secret);
        if (respone?.data?.myToken) {
          Swal.fire({
            icon: "success",
            title: "OTP",
            text: "Demo Account Testing OTP: " + respone?.data?.myToken,
          });
        }
      }
      // })
      // .catch((e) => {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Oops...",
      //     text: "Something went wrong",
      //   });
      // });
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
      return;
    }
    setIsloading1(true);
    try {
      const response = await apiRequest(`login/finish`, "POST", { Phone, twofactor_code, referral, secretCode })

      setIsloading1(false);

      if (response?.data?.status === 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response?.data?.msg,
        });
      } else if (response?.data?.status === 200) {
        const token = response?.data?.token;
        localStorage.setItem("token", token);
        // Reload the page and redirect after a delay
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games"); // Assuming you have 'history' available
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  // otp valid
  const [isValid, setIsValid] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timerInterval;

    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else {
      clearInterval(timerInterval);
      setShowResend(true); // Show the Resend button when OTP expires
      setIsValid(false);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [isValid, seconds]);

  const handleResendClick = (e) => {
    handleClick(e);
    setIsValid(true);
    setSeconds(60);
    setShowResend(false); // Hide the Resend button after clicking it
  };
  return (
    <>
      <div className="leftContainer" style={{ minHeight: "100vh" }}>
        <div className="login_main-area ">
         <div className="gaming-login-card">
          <div className="login-content">

            <h1>Welcome Back!</h1>

            <div className="title-line"></div>

            <p>Login to continue your gaming journey</p>

            <div className="login-form-box">

              <label>Enter Mobile Number</label>

              <div className="gaming-input-group">
                <span>+91</span>

                <input
                  className="form-control"
                  type="tel"
                  placeholder="Mobile Number"
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              {otp && (
                <div className="gaming-input-group mt-3">
                  <span>OTP</span>

                  <input
                    className="form-control"
                    type="tel"
                    placeholder="Enter OTP"
                    onChange={(e) =>
                      settwofactor_code(e.target.value)
                    }
                  />
                </div>
              )}

              {!otp ? (
                <button
                  className="gaming-btn"
                  onClick={(e) => {
                    handleClick(e);
                    setIsValid(true);
                  }}
                >
                  Send OTP
                </button>
              ) : (
                <button
                  className="gaming-btn"
                  onClick={(e) => varifyOtp(e)}
                >
                  Verify OTP
                </button>
              )}

            </div>

            {/* <div className="social-login">
              <span>or continue with</span>

              <div className="social-icons">
                <div className="social-icon google">
                  <i className="fab fa-google"></i>
                </div>

                <div className="social-icon facebook">
                  <i className="fab fa-facebook-f"></i>
                </div>

                <div className="social-icon phone">
                  <i className="fas fa-phone"></i>
                </div>
              </div>
            </div>

            <div className="feature-box">

              <div className="feature-item">
                <i className="fas fa-shield-alt"></i>
                <h5>Secure</h5>
                <p>100% Safe</p>
              </div>

              <div className="feature-item">
                <i className="fas fa-bolt"></i>
                <h5>Fast</h5>
                <p>Login in sec</p>
              </div>

              <div className="feature-item">
                <i className="fas fa-headset"></i>
                <h5>Support</h5>
                <p>24/7 Support</p>
              </div>

            </div> */}

          </div>
         </div>
        </div>
      </div>
    </>
  );
}
